module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/notes-textbox/notes-textbox.component.scss
// module id = ./src/app/shared/components/widgets/notes-textbox/notes-textbox.component.scss
// module chunks = main